import { Injectable } from '@angular/core';
import { ICardHeaderCounter } from '@shared/components/card/card-header/card-header.model';

@Injectable({
  providedIn: 'root',
})
export class CardHeaderCounterMapperService {
  constructor() {}

  mapToCardHeaderCounter(data: Record<string, number>, keyName: Record<string, string>): ICardHeaderCounter[] {
    return Object.keys(keyName).map((key) => ({
      key,
      name: keyName[key],
      value: data[key] ?? 0,
    }));
  }
}
